import { useEffect } from 'react';
import { create } from 'zustand';

interface HeaderTitleState {
  /** 셸 헤더 타이틀 오버라이드 — 없으면 라우트 handle.title 사용. */
  override: string | null;
  set: (title: string | null) => void;
}

const useHeaderTitleStore = create<HeaderTitleState>((set) => ({
  override: null,
  set: (override) => set({ override }),
}));

/** 현재 오버라이드 타이틀(없으면 null) — 셸 헤더(`useRouteTitle`)가 읽어 handle.title 대신 표시. */
export function useHeaderTitleOverride(): string | null {
  return useHeaderTitleStore((state) => state.override);
}

/**
 * 화면이 셸 헤더 타이틀을 **동적으로**(예: 발전소 상세 = 발전소 이름) 덮어쓴다. 값이 falsy 면 오버라이드 없음
 * (handle.title 사용). 언마운트 시 자동 해제하되 **last-writer-wins** — 내가 쓴 값이 아직 유효할 때만 해제한다.
 * native 스택 전환(AnimatePresence)에서 다음 화면이 먼저 마운트(타이틀 set)되고 이전 화면이 늦게 언마운트되며
 * 그 값을 null 로 덮는 단일 슬롯 경합을 방지. 라우트 handle.title 이 정적인 한계를 보완.
 */
export function useSetHeaderTitle(title: string | null | undefined): void {
  const resolved = title ?? null;
  useEffect(() => {
    useHeaderTitleStore.getState().set(resolved);
    return () => {
      if (useHeaderTitleStore.getState().override === resolved) {
        useHeaderTitleStore.getState().set(null);
      }
    };
  }, [resolved]);
}
